import { createSlice } from "@reduxjs/toolkit";
import { RootState } from "../store";

export interface AppState {
    openAIChat: boolean;
}

const initialState: AppState = {
    openAIChat: false,
};

const appSlice = createSlice({
    name: "app",
    initialState,
    reducers: {
        toggleOpenAIChat: (state) => {
            state.openAIChat = !state.openAIChat;
        },
    },
});

export const { toggleOpenAIChat } = appSlice.actions;
export const selectApp = (state: RootState) => state.app;
export default appSlice.reducer;
